<script>
    import {fetchDocs} from "../Data/data.js";

    export let isOpen = false
    export let onClose
    export let selectedCategory = "Compliance"
</script>

{#if isOpen}
    <!-- popup box -->
    <div class="darkerOpacity" id="darkerOpacity" on:click={ onClose }></div>
    <div class="popup" id="popup">

        <div class="docs__header">
            <div class="compliance_cardContainer">
                <div class="popupCloseButton" on:click={ onClose }>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black"/>
                    </svg>
                </div>

                <div class="tittleContainer">
                    <div class="tittle_card">
                        Documentos
                    </div>
                </div>
            </div>
        </div>

        {#await fetchDocs()}
            <p>Puxando arquivos...</p>
        {:then docs}
            <div class="tab-selector">
                {#each Object.keys(docs) as category}
                    <button
                        on:click={() => selectedCategory = category}
                        class="tab-item"
                        class:is-active={ selectedCategory === category }
                    >
                        {category}
                    </button>
                {/each}
            </div>

            <div class="eachDoc">
                {#each docs[selectedCategory] as documents}
                    <div class="doclistContainer">
                        <a href= {documents.link} target="_blank">
                            {documents.name}

                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 16L14 14L1.74846e-07 14L0 16L14 16ZM14 6L10 6L10 -3.49691e-07L4 -8.74228e-07L4 6L8.74228e-07 6L7 13L14 6Z" fill="black"/>
                            </svg>
                        </a>
                    </div>
                {/each}
            </div>
        {/await}
    </div>
{/if}

<style lang="scss">
@use "../styles/variables" as v;

:root {
    --clr-grey: v.$clr-grey;
    --clr-purple: v.$clr-purple;
}

.darkerOpacity {
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.2;
    z-index: 998;
    height: 100%;
    width: 100%;
}

.popup {
    position: fixed;
    width: 98vw;
    padding: 1.5em;
    height: 90vh;
    overflow: auto;
    background: white;
    border: 2px solid var(--clr-grey);
    border-radius: 30px;
    z-index: 999;
    text-transform: none;

    // centralize fixed positioned element
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}


.popupCloseButton {
    float: right;
    padding-top: 0.4em;
    margin-top: 0.5em;
    cursor: pointer;
    width: 2em;
    height: 2em;
    text-align: center;
    border: 2px solid var(--clr-grey);
    border-radius: 30px;

}

.tittleContainer {
    padding-right: 3em;
}

.tittle_card {
    color: v.$clr-purple;
    border: 2px solid var(--clr-grey);
    border-radius: 50px;
    font-weight: 700;
    font-size: 100%;
    width: fit-content;
}


.eachDoc {
    padding-top: 0.5em;

    svg {
        float: right;
    }
}

.doclistContainer {
    font-size: 100%;
    font-weight: 400;
    padding-top: 1em;
    border-bottom: 1.5px v.$clr-grey solid;

    a {
        text-decoration: none;
        color: v.$clr-grey;
    }
}


.doclistContainer:hover{
    color: v.$clr-purple;
    border-bottom: 1.5px v.$clr-purple solid;

    svg path {
        fill: v.$clr-purple;
    }

    a {
        color: v.$clr-purple;
    }
}

.tab-selector {
    margin-top: 1.25rem;

    .tab-item {
      text-decoration: none;
      text-transform: uppercase;
      color: inherit;
      font-size: 0.857rem;
      border: 1px solid #ccc;
      border-radius: 2rem;
      padding: 0.25em 1.4em;
      margin: 0 0.5rem;
      background: none;
    }

    .tab-item:hover, .tab-item.is-active {
      border-color: v.$clr-purple;
      color: v.$clr-purple;
      cursor: pointer;
    }
}

 // Desktop view
 @media only screen and (min-width: v.$md-desktop-devices) {
    .popup {
        width: 85rem;
        padding: 2.5em;
    }

    .popupCloseButton {
        width: 3.1em;
        height: 3.1em;
        padding-top: 0.9em;
        margin-top: 0;
    }

    .tittle_card {
        font-size: 1.71em;
    }

    .eachDoc {
        padding-top: 1.5em;
        svg{
            margin-top: 0.3em;
        }
    }

    .doclistContainer {
        font-size: 1.71em;
        padding-top: 0.38em;
    }
}
</style>
